import React, { useContext, useState } from "react";
// import ReactDom to create react portals
import { ContextProvider } from "../../App";
import { useHistory } from "react-router-dom";

import ReactDOM from "react-dom";
import "./auth.css";
import TextField from "./TextField.jsx";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ReferralsIcon from "../../images/referralsIcon.svg";

import toast, { Toaster } from "react-hot-toast";

import ClipLoader from "react-spinners/ClipLoader";

function SignIn({ signIn, handleSignInClose, handleClickedSignUp }) {
  const { authDispatch } = useContext(ContextProvider);
  const history = useHistory();

  const [signInLoading, setSignInLoading] = useState(false);

  const validate = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is Required"),
      mobile: Yup.number()
      .required("Phone Number is Required")
      .positive("Mobile Number cannot be Negative")
      .integer("Mobile Number should be Number"),
    password: Yup.string()
      .min(6, "Must be 6 characters or more")
      .required("Password is Required"),
  });

  const handleSignInUser = async (values) => {
    setSignInLoading(true);
    try {
      const response = await axios.post("/api/v1/signin", values)
      if (response.data.success === true) {
        authDispatch({ type: "Logged_In_User", payload: response.data});
        localStorage.setItem("userData", JSON.stringify(response.data));
        setSignInLoading(false);
        handleSignInClose();
        // history.push("/food/categories");
      }else {
        setSignInLoading(false);
        toast.error(response.data.message, {
          duration: 3000,
          position: "top-left",
        });
      }
    } catch (error) {
      if (error.response) {
        setSignInLoading(false);
        toast.error(error.response.data.message, {
          duration: 3000,
          position: "top-left",
        });
      }
    }
  };
  return ReactDOM.createPortal(
    // react portals for implement child outside the root id
    <>
      <Toaster />
      <Formik
        initialValues={{
          email: "",
          mobile: "",
          password: "",
        }}
        validationSchema={validate}
        onSubmit={(values, onSubmitProps) => {
          handleSignInUser(values, onSubmitProps);
        }}
      >
        {(formik) => (
          <>
            <div className={signIn ? "backdrop" : "backdropHide"}></div>
            <div
              className={signIn ? "signup_containerOpen" : "signup_container"}
            >
              <Form>
                <div className="signup_header">
                  <p>Sign In</p>
                  <p>
                    <i
                      className="far fa-times-circle"
                      style={{ cursor: "pointer" }}
                      onClick={handleSignInClose}
                    ></i>
                  </p>
                </div>
                <div className="signup_inputs">
                  <TextField
                    type="text"
                    placeholder="Email"
                    name="email"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="text"
                    placeholder="Mobile No"
                    name="mobile"
                    autoComplete="off"
                    className="form_input"
                  />
                  <TextField
                    type="password"
                    placeholder="Password"
                    name="password"
                    autoComplete="off"
                    className="form_input"
                  />
                </div>
                <div className="signup_referral_code">
                  <div className="referral_code">
                    <img src={ReferralsIcon} alt="referral_icon" />
                    <div
                      style={{ marginLeft: ".8rem" }}
                      className="referralsText"
                    >
                      <span>Referral Code</span>
                      <p>Add a personalized gift note to your order</p>
                    </div>
                  </div>
                  <p>
                    <u>View Option</u>
                  </p>
                </div>
                <div className="signup_submit_btn">
                  <button
                    type="submit"
                    className="signUpBtn"
                    disabled={signInLoading ? true : false}
                  >
                    {signInLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "row",
                        }}
                      >
                        <ClipLoader
                          color="#fff"
                          loading={signInLoading}
                          speedMultiplier="1.8"
                          size={20}
                          style={{ marginRight: ".4rem" }}
                        />{" "}
                        <p style={{ marginLeft: ".4rem", color: "#fff" }}>
                          Loading...
                        </p>
                      </div>
                    ) : (
                      "SIGN IN"
                    )}
                  </button>
                </div>
                <div className="q_text">
                  <span>
                    <b>Don't Have an Account ?</b>{" "}
                    <b
                      style={{ color: "#FBA922", cursor: "pointer" }}
                      onClick={handleClickedSignUp}
                    >
                      Sign Up
                    </b>
                  </span>
                </div>
              </Form>
            </div>
          </>
        )}
      </Formik>
    </>,
    document.getElementById("auth-portal-root") // another root id
  );
}

export default SignIn;
